.fl_item__preview {

    &[data-upload-status="uploading"],
    &[data-upload-status="error"],
    &:hover {

        .fl_item__preview_background {
            opacity: 1;
            transition: 0.4s;
        }
    }

    &[data-upload-status="uploading"],
    &[data-upload-status="error"] {

        .fl_item__preview_background {
            background-color: rgba(0, 0, 0, 0.3);
        }
    }

    // &:hover {
    //     .fl_item__preview_background {
    //         background-color: rgba(0, 0, 0, 0.1);background-color
    //     }
    // }
}

.fl_item__preview_background {
    color: #fff;
    opacity: 0;
}

// Video preview styles
.video_preview {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.video_iframe {
    width: 100%;
    height: 100%;
    border: none;
    object-fit: cover;
    pointer-events: none; // Prevent iframe from capturing clicks
}